import { ActiveOrgContext } from '@/contexts/active-org-context'
import * as React from 'react'

export const useActiveOrg = () => {
  const context = React.useContext(ActiveOrgContext)
  if (context === undefined) throw new Error('useActiveOrg must be used within an ActiveOrgProvider')
  return context
}
